import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import ResponsiveDialog from '../../utility/ResponsiveDialog';
import Listing from './';
import { toggleListingModal } from '../../../actions/listing';
import ToriiLoader from '../../utility/ToriiLoader';
import NotFound from '../../utility/NotFound';
import styles from '../../../styles/sass/components/ListingModal.module.scss';

interface Props {
  dispatch: any;
  listing: any;
  listingModalOpen: boolean;
  listingLoading: boolean;
  listingFetched: boolean;
  token: string;
}

export class ListingModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  handleClose = () => this.props.dispatch(toggleListingModal(false));

  render() {
    return (
      <ResponsiveDialog
        className={styles.listingModalContainer}
        onClose={this.handleClose}
        open={this.props.listingModalOpen}
        hideCloseButton
        extraLargePaper
      >
        {this.props.listingLoading ? (
          <ToriiLoader bottom={150} top={150} />
        ) : this.props.listingFetched &&
          this.props.listing &&
          Object.keys(this.props.listing).length !== 0 ? (
          <Listing showInModal />
        ) : (
          <NotFound insideModal handleClose={this.handleClose} />
        )}
      </ResponsiveDialog>
    );
  }
}

const mapStateToProps = (state: any) => ({
  listingFetched: state.listings.listingFetched,
  listing: state.listings.listing,
  listingLoading: state.listings.listingLoading,
  listingModalOpen: state.listings.listingModalOpen,
  token: state.auth.token,
});

export default connect(mapStateToProps)(ListingModal);
